import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, /*GoogleAuthProvider*/ } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAOkW4dM_qs07bTRkq8ywGKjIKsITPa1Dw",
  authDomain: "alien-realty-hub.firebaseapp.com",
  projectId: "alien-realty-hub",
  storageBucket: "alien-realty-hub.appspot.com",
  messagingSenderId: "611878880184",
  appId: "1:611878880184:web:506c26439416c5422b054d",
  measurementId: "G-FJY84TM82T"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);


const googleProvider = new GoogleAuthProvider();
//googleProvider.addScope('https://www.googleapis.com/auth/calendar');
//googleProvider.addScope('https://www.googleapis.com/auth/calendar.events');


export { auth, database, googleProvider };